import type { ClassAttributes } from 'react'

type MutableInputAttributeKey = keyof Omit<
	ClassAttributes<HTMLInputElement>,
	'children' | 'form' | 'list' | 'prefix' | 'style' | 'ref' | 'key'
>

export function selectFiles(
	attributes?: Partial<Record<keyof HTMLInputElement, HTMLInputElement[keyof HTMLInputElement]>>
): Promise<File[]> {
	return new Promise<File[]>((resolve, reject) => {
		const input = document.createElement('input')
		input.type = 'file'
		input.style.display = 'none'

		for (const key in attributes) {
			const attribute = key as MutableInputAttributeKey
			input[attribute] = attributes[attribute]
		}

		input.addEventListener('change', (e) => {
			const target = e.target as HTMLInputElement
			const files = Array.from(target.files ?? [])

			resolve(files)
		})

		input.click()
	})
}
